import {rpAppLink} from "@pg-mono/rp-routes";

import type {IFriendlyPromotionQuery, IPromotionUrlRegion} from "./build_friendly_promotion_slug";
import {buildFriendlyPromotionSlug, buildFriendlyPromotionSlugFromRegion} from "./build_friendly_promotion_slug";
import {PromotionType} from "./PromotionType";

export const buildPromotionListUrl = (data: Partial<IFriendlyPromotionQuery> = {}): string => {
    const friendlySlug = buildFriendlyPromotionSlug(data);

    if (!friendlySlug) {
        return rpAppLink.promotions.list();
    }

    return rpAppLink.promotions.listFriendly({friendlySlug});
};

export const buildPromotionListUrlFromRegion = (data: {region?: IPromotionUrlRegion | null; type?: PromotionType}): string => {
    const friendlySlug = buildFriendlyPromotionSlugFromRegion(data);

    if (!friendlySlug) {
        return rpAppLink.promotions.list();
    }

    return rpAppLink.promotions.listFriendly({friendlySlug});
};
import {rpAppLink} from "@pg-mono/rp-routes";

import type {IFriendlyPromotionQuery, IPromotionUrlRegion} from "./build_friendly_promotion_slug";
import {buildFriendlyPromotionSlug, buildFriendlyPromotionSlugFromRegion} from "./build_friendly_promotion_slug";
import {PromotionType} from "./PromotionType";

export const buildPromotionListUrl = (data: Partial<IFriendlyPromotionQuery> = {}): string => {
    const friendlySlug = buildFriendlyPromotionSlug(data);

    if (!friendlySlug) {
        return rpAppLink.promotions.list();
    }

    return rpAppLink.promotions.listFriendly({friendlySlug});
};

export const buildPromotionListUrlFromRegion = (data: {region?: IPromotionUrlRegion | null; type?: PromotionType}): string => {
    const friendlySlug = buildFriendlyPromotionSlugFromRegion(data);

    if (!friendlySlug) {
        return rpAppLink.promotions.list();
    }

    return rpAppLink.promotions.listFriendly({friendlySlug});
};
